import { createFileRoute, redirect } from "@tanstack/react-router";

type ClerkGlobal = { user?: unknown };

export const Route = createFileRoute("/")({
  // Router mounts inside <ClerkLoaded>, so Clerk is ready here.
  beforeLoad: () => {
    const clerk = (globalThis as { Clerk?: ClerkGlobal }).Clerk;
    if (clerk?.user) {
      throw redirect({ to: "/dashboard" });
    }
    throw redirect({ to: "/sign-in" });
  },
});
